import { StaticImage } from "gatsby-plugin-image";
import React from "react";

import { HOMEPAGE_V2 } from "@config/testIds/app";

import { useTranslate } from "@hooks/useTranslate";
import { useConfig } from "@hooks/useConfig";

import { Service } from "../Service";

export const CleaningProducts: React.FC<{ isComingSoon: boolean }> = ({
  isComingSoon,
}) => {
  const translate = useTranslate("batmaid_pwa_static_homepage");

  const cleaningProductsMarketplaceUrl = useConfig<boolean | undefined>([
    "cleaningProductsMarketplaceUrl",
  ]);

  return (
    <Service
      isComingSoon={isComingSoon}
      cta={translate("services_cleaning_products_cta")}
      title={translate("services_cleaning_products_title")}
      href={`${cleaningProductsMarketplaceUrl}`}
      testId={HOMEPAGE_V2.SERVICES_CLEANING_PRODUCTS}
    >
      <StaticImage
        src={"./products.webp"}
        alt={translate("services_cleaning_products_alt")}
        placeholder="blurred"
        layout="fullWidth"
        quality={100}
      />
    </Service>
  );
};
